import Swal from "sweetalert2";

// --- CSS --- //
import "../styles/alert-utils.css";

// FOR SWAL ALERTS ONLY

// Function to show success message with time out in milliseconds
export const showMessageWithDelay = (title, msg, icon, delay) => {
    Swal.fire({
        title: title,
        text: msg,
        icon: icon,
        timer: delay,
        showConfirmButton: false,
        customClass: {
            popup: 'custom-swal-popup',
        },
    });
};